import { render, staticRenderFns } from "./ViewJob.vue?vue&type=template&id=28edc4fa&scoped=true"
import script from "./ViewJob.vue?vue&type=script&lang=ts"
export * from "./ViewJob.vue?vue&type=script&lang=ts"
import style0 from "./ViewJob.vue?vue&type=style&index=0&id=28edc4fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edc4fa",
  null
  
)

export default component.exports